import React, { useEffect, useContext } from 'react';
import { useCookies } from 'react-cookie';
import AppContext from '../../../../context/AppContext';
import FilledButton from '../../../molecules/buttons/filledButton/FilledButton';
import UnfilledButton from '../../../molecules/buttons/unfilledButton/UnfilledButton';
import { useNavigate, useLocation } from 'react-router-dom';

function CookieConsentModal() {
  const [cookies, setCookie] = useCookies([
    'user-consent',
    'preference-cookies-categories',
    'cookies-performance',
    'cookies-google-analytics',
    'cookies-linkedin',
    'cookies-facebook',
    'cookies-instagram',
    'cookies-pinterest',
    'cookies-youtube',
  ]);

  const { setModalContent, setModalVisible, setCanHideOnClickOutside } = useContext(AppContext);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let timer;
    if (!cookies['user-consent'] && location.pathname !== '/parametrage-cookies') {
      timer = setTimeout(() => {
        setModalContent({
          title: 'Choisissez vos cookies 🍪',
          content: (
            <>
              <p className='mb-lg'>
                <span>
                  Nous utilisons des cookies, car ils sont essentiels pour vous offrir une qualité de navigation
                  optimale et personnalisée, mesurer l'audience de notre site et vous proposer un contenu toujours plus
                  en adéquation avec vos attentes. Mais c’est vous qui gardez le contrôle sur les données que nous
                  collectons et utilisons, bien sûr. En cliquant sur "Accepter", vous acceptez le dépôt de cookies et
                  leur utilisation dans les conditions prévues par notre{' '}
                  <a className='link' href='/politique-confidentialite'>
                    Politique relative aux cookies.
                  </a>
                  Vous pourrez par la suite modifier vos préférences cookies à tout moment en cliquant sur "Gérer mes
                  cookies" en bas de page.
                </span>
              </p>
              <div className='modal-buttons-row mb-sm'>
                <FilledButton onClick={handleParamCookie} type='button' padding='10px 25px'>
                  Paramétrer mes choix
                </FilledButton>
              </div>
              <div className='modal-buttons-row'>
                <UnfilledButton onClick={handleDenied} type='button' padding='10px 25px'>
                  Tout refuser
                </UnfilledButton>
                <FilledButton onClick={handleAccept} type='button' padding='10px 25px'>
                  Tout accepter
                </FilledButton>
              </div>
            </>
          ),
        });
        setModalVisible(true);
        setCanHideOnClickOutside(false);
      }, 500);
    }

    return () => clearTimeout(timer);
  }, [cookies, setModalContent, setModalVisible, location.pathname]);

  function handleAccept() {
    const cookieSettings = [
      { key: 'user-consent', value: 'accepted' },
      { key: 'preference-cookies-categories', value: 'accepted' },
      { key: 'cookies-performance', value: 'accepted' },
      { key: 'cookies-google-analytics', value: 'accepted' },
      { key: 'cookies-linkedin', value: 'accepted' },
      { key: 'cookies-facebook', value: 'accepted' },
      { key: 'cookies-instagram', value: 'accepted' },
      { key: 'cookies-pinterest', value: 'accepted' },
      { key: 'cookies-youtube', value: 'accepted' },
    ];

    cookieSettings.forEach(({ key, value }) => {
      setCookie(key, value, {
        path: '/',
        expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
        secure: true,
        sameSite: 'None',
      });
    });

    setModalVisible(false);
  }

  function handleDenied() {
    const cookieSettings = [
      { key: 'user-consent', value: 'denied' },
      { key: 'preference-cookies-categories', value: 'denied' },
      { key: 'cookies-performance', value: 'denied' },
      { key: 'cookies-google-analytics', value: 'denied' },
      { key: 'cookies-linkedin', value: 'denied' },
      { key: 'cookies-facebook', value: 'denied' },
      { key: 'cookies-instagram', value: 'denied' },
      { key: 'cookies-pinterest', value: 'denied' },
      { key: 'cookies-youtube', value: 'denied' },
    ];

    cookieSettings.forEach(({ key, value }) => {
      setCookie(key, value, {
        path: '/',
        expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
        secure: true,
        sameSite: 'None',
      });
    });

    setModalVisible(false);
  }

  function handleParamCookie() {
    setModalVisible(false);
    navigate('/parametrage-cookies');
  }

  return null;
}

export default CookieConsentModal;
